import { MutationTree } from 'vuex'
import { DocState } from '@/store/storeTypes'
import StageDescription from '@/ts/model/StageDescription'
import DocListItem from '@/ts/if/DocListItem'

const mutations: MutationTree<DocState> = {
  prepare: (state, { id }) => {
    state.docId = id
    state.docState = 'preparing'
    state.docOrdered = false
  },
  ready: (state, { stage, isOrdered }) => {
    state.docState = 'ready'
    state.stageDescription = stage
    state.docOrdered = isOrdered
  },
  close: (state) => {
    state.docId = ''
    state.docState = 'notexists'
    state.docOrdered = false
  },
  init: (state) => {
    state.docId = ''
    state.docState = 'notexists'
    state.docOrdered = false
  },
  setStage: (state, stage: StageDescription) => {
    console.log('setStage', stage)
    state.stageDescription = stage
  },
  setUserDocs: (state, { list }: { list: DocListItem[] }) => {
    state.userDocs = list
  }
}

export default mutations
